<script setup>
const enter = (element) => {
	const width = getComputedStyle(element).width

	element.style.width = width
	element.style.position = 'absolute'
	element.style.visibility = 'hidden'
	element.style.height = 'auto'

	const height = getComputedStyle(element).height

	element.style.width = null
	element.style.position = null
	element.style.visibility = null
	element.style.height = 0

	getComputedStyle(element).height
	requestAnimationFrame(() => {
		element.style.height = height
	})
}

const afterEnter = (element) => {
	element.style.height = 'auto'
}

const leave = (element) => {
	const height = getComputedStyle(element).height

	element.style.height = height

	getComputedStyle(element).height

	requestAnimationFrame(() => {
		element.style.height = 0
	})
}
</script>

<template>
	<transition name="trans-expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
		<slot />
	</transition>
</template>

<style scoped>
@reference '../../../../css/theme.css';

* {
	@apply transform-gpu will-change-[height,opacity];
	backface-visibility: hidden;
	-webkit-perspective: 1000;
	-moz-perspective: 1000;
	-ms-perspective: 1000;
	perspective: 1000;
}
</style>

<style>
@reference '../../../../css/theme.css';

.trans-expand-enter-active,
.trans-expand-leave-active {
	@apply overflow-hidden transition-[height] duration-500 ease-[ease];
}

.trans-expand-enter,
.trans-expand-leave-to {
	@apply h-0;
}
</style>
